var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vuec-app"},[_c('v-app',[_c('router-view')],1),_c('footer',[_vm._v(" "+_vm._s(_vm.version)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }